import axios from 'axios';
import {BED, ROOM,BED_ROOMS} from '../../../service/constants.service';
import Room from '../../../components/set-up/_hotels/_sub/Room';
import {GlobalUtility} from '../../../service/global-utility.service';
import {ALL_ROOMS_WITH_BED} from '@/service/constants.service';

const state = {
  room : {},
  rooms : [],
  rooms_beds:{},

  newRoom:{
    //todo details here.
    hotel_id : '',
    floor_id : '',
    max_person: '',
    status : '',
  },
};

const mutations = {
  set_rooms : (state,params) =>{
    state.rooms = params;
  },

  set_room : (state,param) =>{
    state.room = param;
  },

  set_new_room : (state,param) =>{
    state.rooms.push(param);
    state.newRoom = {
      hotel_id : '',
      floor_id : '',
      max_person: '',
      status,
    }
  },

  set_update_room : (state,param) =>{
    let room = state.rooms.find(room => room.id === param.id);
    Object.assign(room,param);
  },

  set_delete_room : (state,param) =>{

  },

  set_null_room : (state) =>{
    state.rooms = [];
    state.room = {};
  },

  set_rooms_beds: (state, param) => {
    state.rooms_beds = param;
  }

};

const actions = {
 async getRooms({commit}){
   return axios.get(ROOM).then((response)=>{
     commit('set_rooms',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Get Rooms');
     return false;
   });
  },

  viewRoom({commit},param){
   return axios.get(`${ROOM}/${param.id}`).then((response)=>{
     commit('set_room',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Get Room Details');
     return false;
   })
  },

  createRoom({commit},param){
   return axios.post(ROOM,param).then((response)=>{
     const room = {
       id : response.data.id,
       code : response.data.code,
       name : response.data.name,
       max_person : response.data.max_person,
       floor_id : response.data.floor_id,
       hotel_id : response.data.hote_id,
       status : response.data.status,
     };
     commit('set_new_room',room);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Create Room Record');
     return false;
   })
  },

  updateRoom({commit},params){
   return axios.put(`${ROOM}/${params.id}`,params).then((response)=>{
     commit('set_update_room',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Update Room');
     return false;
   });
  },

  deleteRoom(){

  },

  getBedRooms({commit},param){
   return axios.get(`${BED_ROOMS}/${param.id}`).then((response)=>{
     let room = {
       id : response.data.id,
       code : response.data.code,
       name : response.data.name,
       floor_id : response.data.floor_id,
       hotel_id : response.data.hotel_id,
       max_person : response.data.max_person,
       status : response.data.status,
     };
     //commit('set_beds',response.data.beds_per_room);
     commit('set_beds',response.data.beds);
     commit('set_room',room);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Get BedRooms');
     return false;
   });
  },


  setNullRoom({commit}){
   commit('set_null_room');
  },

  getAllRoomsWithBeds({commit},param){
    return axios.get(`${ALL_ROOMS_WITH_BED}/${param.floor_id}`).then((response)=>{
      // console.log('Blooob',response.data);
      commit('set_rooms_beds',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Room With Beds');
      return false;
    })
  }

};

const getters = {
  rooms : state => state.rooms,
  room : state => state.room,
  newRoom : state => state.newRoom,
  rooms_beds: state => state.rooms_beds,
};

export default {state,actions,mutations,getters};
